import React from "react";

// estado inicial
const AuthApi = React.createContext({
  authentication: false,
  sesion: false,
  id: "",
  id_rol: "",
  correo: "",
  claveMunicipio: "",
  colorPrincipal: "",
  token: "",
});


export default AuthApi;
